import { motion } from "framer-motion";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import OTPInput from "../components/auth/OTPInput";
import useCountdown from "../hooks/useCountdown";
import { e2p, p2e } from "../utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";
import useAuthStore from "../store/auth.store";
import Cookies from "js-cookie";

const OtpScreen = () => {
  const navigate = useNavigate();

  const [isEnded, setIsEnded] = useState(false);

  const [otpCode, setOtpCode] = useState(Array(6).fill(""));
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isError, setIsError] = useState(false);

  const username = useAuthStore((state) => state.username);

  const { minutes, seconds, restart } = useCountdown({
    duration: 120,
    onTimeEnd: () => setIsEnded(true),
  });

  const onResendCode = async () => {
    await axios.post(API_BASE_URL + "v1/auth/login/", {
      phone_number: 98 + p2e(username?.slice(1) as string),
      organization: 1,
    });

    restart();
    setIsEnded(false);
    toast.success("کد اعتبارسنجی با موفقیت ارسال شد.");
    setOtpCode(Array(6).fill(""));
  };

  const handleOTPComplete = async () => {
    setIsLoading(true);

    try {
      const response: any = await axios.post(API_BASE_URL + "v1/auth/login/", {
        phone_number: 98 + p2e(username?.slice(1) as string),
        organization: 1,
        code: otpCode?.join(""),
      });

      const userToken = response?.data?.token;

      Cookies.set("mci_elecamp_token", userToken, { expires: 365 });

      toast.success("شما با موفقیت وارد شدید");
      navigate("/vote/song");
    } catch (error: any) {
      setIsError(true);
      toast.error("کد وارد شده معتبر نیست!");
    } finally {
      setIsLoading(false);
      setOtpCode(Array(6).fill(""));
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center px-4">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-black text-xl md:text-3xl font-bold leading-relaxed mb-6"
      >
        کد تایید ارسال شده را
        <br />
        وارد نمایید
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="w-full max-w-xs"
      >
        <OTPInput
          length={6}
          onComplete={handleOTPComplete}
          setIsDisabled={setIsDisabled}
          isError={isError}
          setIsError={setIsError}
          otp={otpCode}
          setOtp={setOtpCode}
        />
      </motion.div>

      {!isEnded ? (
        <p className="font-semibold w-max mx-auto text-black mt-5">
          زمان باقی مانده
          <span className="mx-2 text-primary" dir="ltr">
            {e2p(`${minutes}`)} : {e2p(`${seconds}`)}
          </span>
        </p>
      ) : (
        <button onClick={onResendCode} className="text-primary font-semibold">
          ارسال مجدد
        </button>
      )}

      <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        onClick={handleOTPComplete}
        className="mt-6 bg-[#2a95db] text-white  min-w-[8rem] px-8 py-3 rounded-xl text-lg md:text-xl font-bold shadow-lg hover:bg-blue-600 transition"
        disabled={isDisabled}
      >
        {isLoading ? <ClipLoader color="#fff" size={24} /> : "تایید"}
      </motion.button>
    </div>
  );
};

export default OtpScreen;
